import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { FaLock } from "react-icons/fa";

const CheckoutForm = ({ ppv_event }: any) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState<boolean>();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      if (paymentIntent) {
        switch (paymentIntent.status) {
          case "succeeded":
            setMessage("Payment succeeded!" as any);
            break;
          case "processing":
            setMessage("Your payment is processing." as any);
            break;
          case "requires_payment_method":
            setMessage(
              "Your payment was not successful, please try again." as any
            );
            break;
          default:
            setMessage("Something went wrong." as any);
            break;
        }
      }
    });
  }, [stripe]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${process.env.REACT_APP_FRONTEND_URL}/ppv/success`,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message as any);
    } else {
      setMessage("An unexpected error occurred." as any);
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        id="payment-element"
        options={{
          layout: "tabs",
        }}
      />
      <div className="mt-6 flex items-center gap-2">
        <button
          disabled={isLoading || !stripe || !elements}
          id="submit"
          className="button-red flex min-w-[160px] items-center justify-center gap-2 rounded-full px-5 py-3 font-semibold text-white shadow-lg shadow-[var(--red)]/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60 max-sm:w-full"
        >
          <FaLock className="text-[13px]" />
          <span id="button-text">
            {isLoading ? "Processing..." : "Pay now"}
          </span>
        </button>
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-[12px] text-gray-400">
        <FaLock className="text-[10px]" />
        Payments are secure and encrypted by Stripe
      </p>
      {/* Show any error or success messages */}
      {message && (
        <div className="mt-6" id="payment-message">
          <span className="text-red-400">{message}</span>
        </div>
      )}
    </form>
  );
};

export default CheckoutForm;